/**
 * @overview 预约安排
 * @author jzhu
 * @date 2020-9-1
 */

import React from 'react'
import { connect } from 'dva'
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool, component_tool } from '../../../../tool'
import store from 'store2';
import moment from 'moment';
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool
let { WizBrowserExport } = component_tool

class SiteAppointmentArrangement extends WizContainer {

    componentName = 'SiteAppointmentArrangement'

    constructor(props) {
        super(props)
        this.state = {}
        this._map = {
            columns: []
        }
        this._columnsMap = this._columnsExcelMap()
    }

    componentWillMount() {
        try {
            // 如果有搜索条件,执行缓存页
            if (sessionStorage.getItem('searchMap')) {
                const _key = window.location.hash
                const _searchMap = store.session('searchMap') || []
                const filterSearch = _searchMap.filter(val => val.key === _key)
                if (filterSearch.length) {
                    let { start, end } = filterSearch[0]['value']['list']
                    this.setState({
                        start: start ? new Date(start) : '',
                        end: end ? new Date(end) : '',
                    })
                }
            }
        } catch (err) {
            console.log(err)
        }
    }

    propsAndStateOnChange = {
        list: this._list.bind(this),
    }

    _list(nextProps, nextState) {
        let { success } = nextProps['list'];
        if (!success) {
            nextState['start'] = ''
            nextState['end'] = ''
        }
        return true;
    }

    _columnsExcelMap = () => {
        let basic = [
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z'
        ]
        let result = {}
        let index = 1
        basic.forEach(item => {
            result[index] = item
            index++
        })
        for (let i = 0; i < basic.length; i++) {
            for (let j = 0; j < basic.length; j++) {
                let item = basic[i] + basic[j]
                result[index] = item
                index++
            }
        }
        return result
    }

    _columns = () => {
        let defaultExportProps = {
            cellStyle: {
                textAlign: 'center',
            },
            style: {
                alignment: { vertical: 'bottom', horizontal: 'left' },
            }
        }
        let columns = [
            {
                headerName: '',
                width: 30,
                field: 'rowIndex',
                hidden: true,
                suppressMovable: true,
                cellStyle: {
                    textAlign: 'center',
                    padding: '5px 0',
                    color: '#595959',
                    backgroundColor: '#f0f0f0',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '500',
                    boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
                },
            },
            {
                headerName: '场地名称',
                field: 'name',
                width: 25,
                ...defaultExportProps
            },
            {
                headerName: '场地编号',
                field: 'code',
                width: 25,
                ...defaultExportProps
            },
            {
                headerName: '城市',
                field: 'city',
                width: 15,
                ...defaultExportProps
            }
        ]
        columns = columns.concat(this._map.columns)
        return columns
    }

    _rows = (data) => {
        let rows = []
        let rowMergeCell = []
        let index = 1
        data && data.length && data.forEach(obj => {
            let { id, name, code, city, map } = obj
            let row = {
                id,
                name,
                code,
                city
            }
            let keys = Object.keys(map)
            keys && keys.length && keys.forEach(key => {
                let { fullName, orderMobile, start, end, colSpan } = map[key]
                row[key] = '预约人： ' + (fullName || '') + ' \n联系电话： ' + (orderMobile || '') + ' \n预约时间： ' + (start + ' ~ ' + end)
                let i = this._map[key]
                let s = this._columnsMap[i + 3]
                let e = this._columnsMap[i + 3 - 1 + colSpan]
                let r = index + 3
                rowMergeCell.push(s + r + ':' + e + r)
            })
            rows.push(row)
            index++
        })
        return { rows, rowMergeCell }
    }

    _export = (nextProps, nextState, key) => {
        let o = nextProps[key]
        if (o.success) {
            let columns = this._columns()
            let { rows, rowMergeCell } = this._rows(o.data)
            WizBrowserExport({
                title: '预约安排',
                sheetName: '预约安排',
                columns: columns.filter((_, index) => index),
                rows,
                filename: '预约安排.xlsx',
                rowMergeCell
            })
            return true
        } else {
            wizNotice.error(o.msg)
            return false
        }
    }

    _render() {
        let { start, end } = this.state
        console.log(start, end)
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig: templateConfig(this),
            apiDataFormat: {
                export: this._export
            }
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    const { siteOrderStatistic } = state;
    const list = modelUtils.getModelEntity(siteOrderStatistic, 'siteOrderStatistic@appointmentArrangement');
    return {
        list
    }
}

export default connect(mapStateToProps)(SiteAppointmentArrangement)
